export default "/assets/webpack-assets/GT-Walsheim-Pro-Light.39e23e8dcc12250f70551b8baf74b7cb.woff";